import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  margin: 40px 0px 0px !important;
  padding: 0px 20px !important;
  gap: 40px;
  background: var(--Shades-0, #fff);
  ${media.md`
    margin: 60px 0px 64px !important;
    padding: 0px 60px !important;
    gap:60px;
  `}
  ${media.lg`
    margin: 0px !important;
  
  `}
  
  @media (min-width: 1200px) and (max-width: 1399px) {
    margin: 100px auto 0px !important;
    padding: 0px !important;
    gap: 72px;
    max-width: 1040px !important;
  }

  @media (min-width: 1400px) {
    max-width: 1240px !important;
    margin: 100px auto 0px !important;
    padding: 0px !important;
    gap: 72px;
  }
`;

export const StyledContentBlock = styled.div`
  display: flex !important;
  flex-direction: column !important;
  align-items: center;
  padding: 0px !important;
`;

export const Header = styled.h2`
  color: var(--Shades-900, #1c1c1c);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  text-align: center;
  font-style: normal;
  font-size: ${props => (props.locale === 'ru' ? '35px' : '40px')};
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: ${props => (props.locale === 'ru' ? '40px' : '90%')};
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 0px;
  ${media.md`
    font-size: 60px;

    line-height: 85%; 
    letter-spacing: -1.2px;
  `}
  ${media.lg`
    font-size: 60px;

    letter-spacing: -1.2px;
  `}
  ${media.xl`
    font-size: 70px;
    max-width:1240px;
    
    letter-spacing: -1.4px;
    line-height: ${props =>
      props.locale === 'ru' ? '50px !important' : '85% !important'};
  `}
`;
